export default __webpack_public_path__ + "static/IN-8015v6014_resTestBig2-9f925d1ac23d87bcd704e89b23ca25a4.webp";